const bulkBookingInformation = (state = null, action) => {
  if (action.type === "SET_BULK_BOOKING_INFORMATION") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_BULK_BOOKING_INFORMATION": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default bulkBookingInformation;
